









import { mapFields } from 'vuex-map-fields'

export default
    computed: {
        ...mapFields('search', {
            'title'
        })
    }

